export default "__VITE_ASSET__DAM5GwBq__"